module.exports = __webpack_public_path__ + "img/div6-4s.35af1068.jpg";